"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BasesService", {
    enumerable: true,
    get: function() {
        return BasesService;
    }
});
const _util = require("util");
const _common = require("@nestjs/common");
const _isomorphicdompurify = /*#__PURE__*/ _interop_require_wildcard(require("isomorphic-dompurify"));
const _nanoid = require("nanoid");
const _nocodbsdk = require("nocodb-sdk");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _extractProps = require("~/helpers/extractProps");
const _syncMigration = /*#__PURE__*/ _interop_require_default(require("~/helpers/syncMigration"));
const _models = require("~/models");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _ncconfig = require("~/utils/nc-config");
const _metaservice = require("~/meta/meta.service");
const _globals = require("~/utils/globals");
const _tablesservice = require("~/services/tables.service");
const _modelUtils = require("~/utils/modelUtils");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
const nanoid = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz_', 4);
let BasesService = class BasesService {
    async baseList(context, param) {
        var _param_user;
        const bases = (0, _nocodbsdk.extractRolesObj)((_param_user = param.user) == null ? void 0 : _param_user.roles)[_nocodbsdk.OrgUserRoles.SUPER_ADMIN] ? await _models.Base.list() : await _models.BaseUser.getProjectsList(param.user.id, param.query);
        return bases;
    }
    async getProject(context, param) {
        const base = await _models.Base.get(context, param.baseId);
        return base;
    }
    async getProjectWithInfo(context, param) {
        const { includeConfig = true } = param;
        const base = await _models.Base.getWithInfo(context, param.baseId, includeConfig);
        return base;
    }
    sanitizeProject(base) {
        var _sanitizedProject_sources;
        const sanitizedProject = _extends({}, base);
        (_sanitizedProject_sources = sanitizedProject.sources) == null ? void 0 : _sanitizedProject_sources.forEach((b)=>{
            [
                'config'
            ].forEach((k)=>delete b[k]);
        });
        return sanitizedProject;
    }
    async baseUpdate(context, param) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ProjectUpdateReq', param.base, false, {
            api_version: param.apiVersion
        });
        const base = await _models.Base.getWithInfo(context, param.baseId);
        // stringify meta prop then only we can make the sanitize function work
        if ('meta' in param.base) {
            param.base.meta = (0, _modelUtils.stringifyMetaProp)(param.base);
        }
        const data = (0, _extractProps.extractPropsAndSanitize)(param == null ? void 0 : param.base, [
            'title',
            'meta',
            'color',
            'status',
            'order',
            'description',
            'default_role',
            'version'
        ]);
        await this.validateProjectTitle(context, data, base);
        if ((data == null ? void 0 : data.order) !== undefined) {
            data.order = !isNaN(+data.order) ? +data.order : 0;
        }
        const result = await _models.Base.update(context, param.baseId, data);
        this.appHooksService.emit(_nocodbsdk.AppEvents.PROJECT_UPDATE, {
            base: _extends({}, base, data),
            updateObj: data,
            oldBaseObj: base,
            user: param.user,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEventToBaseUsers(context, {
            event: _nocodbsdk.EventType.USER_EVENT,
            payload: {
                action: 'base_update',
                payload: _extends({}, base, data)
            }
        }, context.socket_id);
        return result;
    }
    async validateProjectTitle(context, data, base) {
        if ((data == null ? void 0 : data.title) && base.title !== data.title && await _models.Base.getByTitle({
            workspace_id: _globals.RootScopes.BASE,
            base_id: _globals.RootScopes.BASE
        }, data.title)) {
            _catchError.NcError.badRequest('Base title already in use');
        }
    }
    async baseSoftDelete(context, param, ncMeta = _Noco.default.ncMeta) {
        const base = await _models.Base.getWithInfo(context, param.baseId, undefined, ncMeta);
        if (!base) {
            _catchError.NcError.baseNotFound(param.baseId);
        }
        const transaction = await ncMeta.startTransaction();
        try {
            await _models.Base.softDelete(context, param.baseId, transaction);
            await transaction.commit();
        } catch (e) {
            await transaction.rollback();
            if (e instanceof _catchError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
            this.logger.error('Error deleting base', e);
            _catchError.NcError.get(context).internalServerError('Failed to delete base');
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.PROJECT_DELETE, {
            base,
            user: param.user,
            req: param.req,
            context
        });
        return true;
    }
    async baseCreate(param, ncMeta = _Noco.default.ncMeta) {
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ProjectReq', param.base, false, {
            api_version: param == null ? void 0 : param.apiVersion
        });
        const baseId = await this.metaService.genNanoid(_globals.MetaTable.PROJECT);
        const baseBody = param.base;
        baseBody.id = baseId;
        if (!baseBody.external) {
            var _Noco_getConfig_meta, _Noco_getConfig;
            const ranId = nanoid();
            baseBody.prefix = `nc_${ranId}__`;
            baseBody.is_meta = true;
            const dataConfig = await ((_Noco_getConfig = _Noco.default.getConfig()) == null ? void 0 : (_Noco_getConfig_meta = _Noco_getConfig.meta) == null ? void 0 : _Noco_getConfig_meta.db);
            if ((dataConfig == null ? void 0 : dataConfig.client) === 'pg' && process.env.NC_DISABLE_PG_DATA_REFLECTION !== 'true') {
                baseBody.prefix = '';
                baseBody.sources = [
                    {
                        type: 'pg',
                        is_local: true,
                        is_meta: false,
                        config: {
                            schema: baseId
                        },
                        inflection_column: 'camelize',
                        inflection_table: 'camelize'
                    }
                ];
            } else if ((dataConfig == null ? void 0 : dataConfig.client) === 'sqlite3' && process.env.NC_MINIMAL_DBS === 'true') {
                // if env variable NC_MINIMAL_DBS is set, then create a SQLite file/connection for each base
                // each file will be named as nc_<random_id>.db
                const fs = require('fs');
                const toolDir = (0, _ncconfig.getToolDir)();
                const nanoidv2 = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz', 14);
                if (!await (0, _util.promisify)(fs.exists)(`${toolDir}/nc_minimal_dbs`)) {
                    await (0, _util.promisify)(fs.mkdir)(`${toolDir}/nc_minimal_dbs`);
                }
                const dbId = nanoidv2();
                const baseTitle = _isomorphicdompurify.sanitize(baseBody.title);
                baseBody.prefix = '';
                baseBody.sources = [
                    {
                        type: 'sqlite3',
                        is_meta: false,
                        is_local: true,
                        config: {
                            client: 'sqlite3',
                            connection: {
                                client: 'sqlite3',
                                database: baseTitle,
                                connection: {
                                    filename: `${toolDir}/nc_minimal_dbs/${baseTitle}_${dbId}.db`
                                }
                            }
                        },
                        inflection_column: 'camelize',
                        inflection_table: 'camelize'
                    }
                ];
            } else {
                var _Noco_getConfig_meta1;
                const db = (_Noco_getConfig_meta1 = _Noco.default.getConfig().meta) == null ? void 0 : _Noco_getConfig_meta1.db;
                baseBody.sources = [
                    {
                        type: db == null ? void 0 : db.client,
                        config: null,
                        is_meta: true,
                        inflection_column: 'camelize',
                        inflection_table: 'camelize'
                    }
                ];
            }
        } else {
            if (process.env.NC_CONNECT_TO_EXTERNAL_DB_DISABLED) {
                _catchError.NcError.badRequest('Connecting to external db is disabled');
            }
            for (const source of baseBody.sources || []){
                if (!source.fk_integration_id) {
                    var _source_config, _param_req_user, _param_req, _param_req_user1, _baseBody_config;
                    const integration = await _models.Integration.createIntegration({
                        title: source.alias || baseBody.title,
                        type: _nocodbsdk.IntegrationsType.Database,
                        sub_type: (_source_config = source.config) == null ? void 0 : _source_config.client,
                        is_private: !!((_param_req_user = param.req.user) == null ? void 0 : _param_req_user.id),
                        config: source.config,
                        workspaceId: (_param_req = param.req) == null ? void 0 : _param_req.ncWorkspaceId,
                        created_by: (_param_req_user1 = param.req.user) == null ? void 0 : _param_req_user1.id
                    }, ncMeta);
                    source.fk_integration_id = integration.id;
                    source.config = {
                        client: (_baseBody_config = baseBody.config) == null ? void 0 : _baseBody_config.client
                    };
                }
            }
            baseBody.is_meta = false;
        }
        if ((baseBody == null ? void 0 : baseBody.title.length) > 50) {
            // Limited for consistent behaviour across identifier names for table, view, columns
            _catchError.NcError.badRequest('Base title exceeds 50 characters');
        }
        baseBody.title = _isomorphicdompurify.sanitize(baseBody.title);
        baseBody.slug = baseBody.title;
        // TODO: set default version to V3 after beta of v3 is over
        baseBody.version = param.base.version || _nocodbsdk.BaseVersion.V2;
        const base = await _models.Base.createProject(baseBody, ncMeta);
        const context = {
            workspace_id: base.fk_workspace_id,
            base_id: base.id
        };
        // TODO: create n:m instances here
        await _models.BaseUser.insert(context, {
            fk_user_id: param.user.id,
            base_id: base.id,
            roles: 'owner'
        }, ncMeta);
        await (0, _syncMigration.default)(base);
        // populate metadata if existing table
        for (const source of (await base.getSources(undefined, ncMeta))){
            if (process.env.NC_CLOUD !== 'true' && !base.is_meta) {
                const info = await (0, _helpers.populateMeta)(context, {
                    source,
                    base,
                    user: param.user
                });
                this.appHooksService.emit(_nocodbsdk.AppEvents.APIS_CREATED, {
                    info,
                    req: param.req,
                    context
                });
                source.config = undefined;
            }
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.PROJECT_CREATE, {
            base,
            user: param.user,
            xcdb: !baseBody.external,
            req: param.req,
            context
        });
        return base;
    }
    async createDefaultBase(param, ncMeta = _Noco.default.ncMeta) {
        const base = await this.baseCreate({
            base: {
                title: 'Getting Started',
                type: 'database'
            },
            user: param.user,
            req: param.req
        }, ncMeta);
        const context = {
            workspace_id: base.fk_workspace_id,
            base_id: base.id
        };
        const sqlUI = _nocodbsdk.SqlUiFactory.create({
            client: base.sources[0].type
        });
        const columns = sqlUI == null ? void 0 : sqlUI.getNewTableColumns();
        const table = await this.tablesService.tableCreate(context, {
            baseId: base.id,
            sourceId: base.sources[0].id,
            table: {
                title: 'Features',
                table_name: 'Features',
                columns
            },
            user: param.user,
            req: param.req
        });
        base.tables = [
            table
        ];
        return base;
    }
    constructor(appHooksService, metaService, tablesService){
        this.appHooksService = appHooksService;
        this.metaService = metaService;
        this.tablesService = tablesService;
        this.logger = new _common.Logger(BasesService.name);
    }
};
BasesService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _metaservice.MetaService === "undefined" ? Object : _metaservice.MetaService,
        typeof _tablesservice.TablesService === "undefined" ? Object : _tablesservice.TablesService
    ])
], BasesService);
